import { defineStore } from 'pinia'
import type { NewCartItem } from '~/types'

export const useAddToCartModal = defineStore('addToCartModal', () => {
  const open = ref(false)
  const item = ref<NewCartItem | null>(null)

  const show = (itemPayload: NewCartItem) => {
    item.value = itemPayload
    open.value = true
  }

  const hide = () => {
    open.value = false
  }

  watch(open, (newVal) => {
    if (!newVal) {
      item.value = null
    }
  })

  return {
    open,
    item,
    show,
    hide,
  }
})